import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import { Divider } from '../components/Divider';
import './Accommodation.css';

export function Accommodation() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.accommodation.anchor} className="section stay">
      <Divider />
      <div className="section-header">
        <div className="section-kicker">{t('accommodation.kicker')}</div>
        <h2 className="section-title">{t('accommodation.title')}</h2>
      </div>

      <p className="stay__intro">{t('accommodation.intro')}</p>

      <ol className="stay__steps">
        <li>{t('accommodation.step1')}</li>
        <li>{t('accommodation.step2')}</li>
        <li>{t('accommodation.step3')}</li>
        <li>{t('accommodation.step4')}</li>
      </ol>

      <div className="stay__code">
        <span className="stay__code-label">{t('accommodation.codeLabel')}</span>
        <span className="stay__code-value">{siteConfig.links.accommodationCode}</span>
      </div>

      <a
        className="btn"
        href={siteConfig.links.accommodationBooking}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('accommodation.cta')}
      </a>
    </section>
  );
}
